import React from "react";
import { COLORS } from "../constants/colors";
import { Presentation } from 'lucide-react';
import { Tooltip } from "@mui/material";

export const DetailsPanelFile = ({ data }) => {
  const firstValue = Object.values(data ?? {})[0];

  if (!firstValue) {
    return (
      <div className="flex h-full items-center justify-center text-gray-500">
        No data available
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl shadow-sm ">

      {/* KPI Components */}
      <div className="my-[3px]">
        <h3 className="text-lg font-semibold mb-4 text-gray-900">
          KPI Components
        </h3>

        {firstValue?.kpiComponents?.length > 0 ? (
          <div className="grid grid-cols-[repeat(auto-fit,minmax(260px,1fr))] gap-4">
            {firstValue.kpiComponents.map((group, index) => (
              <div
                key={index}
                className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm"
              >
                <div className="mb-3 text-sm font-semibold uppercase tracking-wider text-[#FF03F3]">
                  {group.source}
                </div>

                {/* TABLES */}
                {group.source === "Table" &&
                  group.tables?.map((item, idx) => (
                    <div
                      key={idx}
                      className="mb-2 rounded-lg border border-gray-200 bg-gray-50 px-3 py-2"
                    >
                      <div className="text-sm font-medium text-gray-900">
                        {item.tableName}
                      </div>

                      {item.columns?.length > 0 && (
                        <div className="mt-1 text-xs text-gray-500">
                          Columns: {item.columns.join(", ")}
                        </div>
                      )}
                    </div>
                  ))}

                {/* MEASURES */}
                {group.source === "Measure" &&
                  group.measures?.map((item, idx) => (
                    <div
                      key={idx}
                      className="mb-2 rounded-lg border border-gray-200 bg-gray-50 px-3 py-2"
                    >
                      <div className="text-sm font-medium text-gray-900">
                        {item.measureName}
                      </div>
                    </div>
                  ))}

                {/* EMPTY STATE */}
                {!group.tables?.length && !group.measures?.length && (
                  <div className="text-sm text-gray-500">No data available</div>
                )}
              </div>
            ))}
          </div>
        ) : (
          <div className="text-sm text-gray-500">No data available</div>
        )}

      </div>

      {/* Where to find */}
      <div className="mb-3 mt-[22px] w-full min-w-0">
        <h3 className="text-lg font-semibold mb-4 text-gray-900">
          Where to find
        </h3>

        {firstValue?.whereToFindData?.length > 0 ? (
          <div className="grid w-full min-w-0 grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {firstValue.whereToFindData.map((item, index) => {

              return (
                <div
                  key={index}
                  className="w-full min-w-0 rounded-lg border border-gray-200 bg-white p-4 flex gap-3"
                >
                  <span className="mt-1 h-2.5 w-2.5 shrink-0 rounded-full bg-[#475bcc]" />

                  <div className="flex-1 min-w-0">
                    <div className="text-sm font-medium text-gray-900 truncate">
                      <Tooltip
                        arrow
                        placement="top"
                        title={item.pageName}
                        disablePortal={false}
                        PopperProps={{
                          sx: {
                            zIndex: 9999,
                          },
                        }}
                      >
                        <span className="block cursor-pointer">
                          {item.pageName}
                        </span>
                      </Tooltip>

                    </div>


                    <div className="mt-1 flex items-center gap-2 text-sm text-gray-600">
                      <Presentation className="h-5" />

                      {Array.isArray(item.type) && item.type.length > 0 && (() => {
                        const [first, ...rest] = item.type;
                        const format = s =>
                          s.replace(/([A-Z])/g, " $1").replace(/^./, c => c.toUpperCase());

                        return (
                          <>
                            <span>{format(first)}</span>

                            {rest.length > 0 && (
                              <Tooltip
                                title={
                                  <div className="flex flex-col gap-1">
                                    {rest.map((t, i) => (
                                      <span key={i}>{format(t)}</span>
                                    ))}
                                  </div>
                                }
                                arrow
                              >
                                <span className="cursor-pointer text-gray-500">
                                  +{rest.length}
                                </span>
                              </Tooltip>
                            )}
                          </>
                        );
                      })()}
                    </div>

                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="text-sm text-gray-500">No data available</div>
        )}
      </div>


      {/* DAX Calculation */}
      <div>
        <div className="flex items-center justify-between mb-3">
          <h3 className="text-lg font-semibold  mt-[14px] text-gray-900">
            DAX Calculation Logic
          </h3>

        </div>

        <pre className="bg-gray-900 text-gray-100 rounded-lg p-4 text-sm overflow-x-auto">
          <code>{firstValue.calculation || "No calculation available"}</code>
        </pre>
      </div>
    </div>
  );
};
